import { ContentEditableEditorPluginCollection } from '../../base/plugins/contentEditableEditorPluginCollection';
import { ContentEditableHtmlEditorPlugin } from './contentEditableHtmlEditorPlugin';

export class ContentEditableHtmlEditorPluginCollection<
    T extends ContentEditableHtmlEditorPlugin = ContentEditableHtmlEditorPlugin
  >
  extends ContentEditableEditorPluginCollection<T>
  implements Required<ContentEditableHtmlEditorPlugin> {
  get addAllowedAttributes() {
    return this.plugins.reduce(
      (attributes: string[], plugin) =>
        plugin.addAllowedAttributes ? attributes.concat(plugin.addAllowedAttributes) : attributes,
      [],
    );
  }

  isImageInteractive(image: HTMLImageElement): boolean {
    return this.plugins.every(plugin => !plugin.isImageInteractive || plugin.isImageInteractive(image));
  }
}
